import { IconButton, Tooltip } from '@mui/material';
import { DeleteIcon } from '@shared/custom-icons';
import { useCampaignTFunction } from '@retail/campaign/i18n';

interface Props {
  removeItem?: () => void;
}

export const CampaignItemActions = ({ removeItem }: Props) => {
  const t = useCampaignTFunction();

  return removeItem ? (
    <Tooltip title={t('campaign.actions.removeItem')}>
      <IconButton onClick={removeItem} aria-label={t('campaign.actions.removeItem')}>
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  ) : null;
};
